export default __webpack_public_path__ + "static/media/lycopersicum.8bc0db74.jpg";